import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import AddVolunterModal from './AddVolunterModal';
import { getEventAccessLogs, getEventAnalytics, getEventAttendees, getSingleEvent, getVolunteerById, getVolunteers, PostInvaiteUsersToEvent, postVolunteer } from '../../../../Redux/Reducers/communityReducer';
import { useDispatch } from 'react-redux';
import { SlLocationPin } from "react-icons/sl";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { IoCloudOfflineOutline } from "react-icons/io5";
import { PiNotePencil } from "react-icons/pi";
import { FaSpinner } from "react-icons/fa";
import { BiLinkExternal } from "react-icons/bi"; // Added for external link icon
import InviteUserModal from './InviteUserModal';
import StatisticsModal from './StatisticsModal'; // You'll need to create this component

// Loading Spinner Component
const LoadingSpinner = ({ size = 20, color = "#0044C6" }) => (
  <FaSpinner style={{
    animation: "spin 1s linear infinite",
    fontSize: size,
    color: color
  }} />
);

// Add this to your global CSS or in a style tag
const loadingStyles = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// Loading Skeleton for Person Card
const PersonCardSkeleton = () => (
  <div
    style={{
      background: "#FFFFFF",
      borderRadius: "16px",
      padding: "1rem 1.5rem",
      border: "1px solid #E9EDF4",
      display: "flex",
      alignItems: "center",
      gap: "1rem",
      animation: "pulse 1.5s ease-in-out infinite",
    }}
  >
    <div
      style={{
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        background: "#E9EDF4",
        flexShrink: 0,
      }}
    />
    <div style={{ flex: 1 }}>
      <div
        style={{
          height: "16px",
          width: "120px",
          background: "#E9EDF4",
          borderRadius: "4px",
          marginBottom: "8px",
        }}
      />
      <div
        style={{
          height: "12px",
          width: "180px",
          background: "#E9EDF4",
          borderRadius: "4px",
        }}
      />
    </div>
    <div
      style={{
        width: "60px",
        height: "32px",
        background: "#E9EDF4",
        borderRadius: "30px",
        flexShrink: 0,
      }}
    />
  </div>
);

// Loading Skeleton for Stat Item
const StatItemSkeleton = () => (
  <div>
    <div
      style={{
        height: "12px",
        width: "60px",
        background: "#E9EDF4",
        borderRadius: "4px",
        marginBottom: "8px",
      }}
    />
    <div
      style={{
        height: "32px",
        width: "80px",
        background: "#E9EDF4",
        borderRadius: "4px",
      }}
    />
  </div>
);

// Event Link Component for Online Events
const EventLink = ({ link }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleJoinClick = () => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        background: "#F0F5FF",
        padding: "0.5rem 1rem",
        borderRadius: "40px",
        border: isHovered ? "1px solid #0044C6" : "1px solid transparent",
        transition: "all 0.2s",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span style={{ fontSize: "0.9rem", color: "#0044C6", fontWeight: 500 }}>
        Join Online:
      </span>
      <button
        onClick={handleJoinClick}
        style={{
          background: "white",
          color: "#0044C6",
          border: "1px solid #0044C6",
          borderRadius: "30px",
          padding: "0.4rem 1.2rem",
          fontSize: "0.9rem",
          fontWeight: 500,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "0.4rem",
          transition: "all 0.2s",
          boxShadow: isHovered ? "0 4px 10px rgba(0,68,198,0.2)" : "none",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#0044C6";
          e.currentTarget.style.color = "white";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "white";
          e.currentTarget.style.color = "#0044C6";
        }}
      >
        <BiLinkExternal size={16} />
        Join Event
      </button>
    </div>
  );
};

// Main EventDashboard Component
const EventDashboard = ({ eventData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {id} =useParams()
// console.log("NEWWWWWWW_id", id)
  // Loading states
  const [isLoadingVolunteers, setIsLoadingVolunteers] = useState(false);
  const [isLoadingAttendees, setIsLoadingAttendees] = useState(false);
  const [isLoadingAnalytics, setIsLoadingAnalytics] = useState(false);
  const [isAddingVolunteer, setIsAddingVolunteer] = useState(false);
  const [isInvitingAttendees, setIsInvitingAttendees] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState({
    volunteers: false,
    attendees: false
  });

  // Modal states
  const [isStatisticsModalOpen, setIsStatisticsModalOpen] = useState(false);
  const [selectedStatistic, setSelectedStatistic] = useState(null);
  const [selectedStatisticLabel, setSelectedStatisticLabel] = useState('');

  const eventAnalytics = useSelector((state) => state?.community?.eventAnalytics);
  const singleEvent = useSelector((state) => state?.community?.singleEvent);
  const VolunteersData = useSelector((state) => state?.community?.VolunteersData);
  const EventAttendees = useSelector((state) => state.community.EventAttendees);
  const getInviteUserEvent = useSelector((state) => state.community.getInviteUserEvent);

  useEffect(() => {
    dispatch(getSingleEvent(id));
    dispatch(getVolunteers(id));
    dispatch(getEventAttendees(id));
    dispatch(getEventAnalytics(id))
  }, [id])


  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  // Get location from singleEvent
  const eventLocation = singleEvent?.event_location || "";

  // Get date from singleEvent
  const eventDate = formatDate(singleEvent?.start_time);

  // Check if event is online
  const isOnlineEvent = singleEvent?.mode?.toLowerCase() === "online";
  const eventLink = singleEvent?.event_link || "";

  const [volunteers, setVolunteers] = useState([]);
  const [attendees, setAttendees] = useState([]);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [isPersonModalOpen, setIsPersonModalOpen] = useState(false);
  const [selectedPersonType, setSelectedPersonType] = useState('');

  // Separate modal states for different modals
  const [isAddVolunteerModalOpen, setIsAddVolunteerModalOpen] = useState(false);
  const [isInviteUserModalOpen, setIsInviteUserModalOpen] = useState(false);
  const [modalType, setModalType] = useState(''); // 'volunteer' or 'attendee'

  // Simulate loading for demonstration (you can remove this in production)
  useEffect(() => {
    // Simulate initial data loading
    setIsLoadingAnalytics(true);
    setIsLoadingVolunteers(true);
    setIsLoadingAttendees(true);

    // Simulate API calls completion
    const timer = setTimeout(() => {
      setIsLoadingAnalytics(false);
      setIsLoadingVolunteers(false);
      setIsLoadingAttendees(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const handleAddVolunteer = () => {
    setModalType('volunteer');
    setIsAddVolunteerModalOpen(true);
  };

  const handleAddInvite = () => {
    setModalType('attendee');
    setIsInviteUserModalOpen(true);
  };

  const handleViewPersonDetails = (person, type) => {
    dispatch(getVolunteerById(person.id));
    navigate(`/event/${singleEvent?.id}/volunteer/${person.id}`);
  };

  const handleClosePersonModal = () => {
    setIsPersonModalOpen(false);
    setSelectedPerson(null);
    setSelectedPersonType('');
  };

  // Handler for statistic click
  const handleStatisticClick = (label, value) => {
    // Don't open modal for Total Tickets
    if (label === "Total Tickets") return;

    setSelectedStatistic({ label, value });
    setSelectedStatisticLabel(label);
    setIsStatisticsModalOpen(true);
  };

  // Handler for AddVolunterModal (single volunteer addition)
  const handleAddVolunteerUser = async (user, type) => {
    // console.log("Adding single volunteer:", user);
    setIsAddingVolunteer(true);
    try {
      const response = await dispatch(postVolunteer({
        eventId: singleEvent?.id,
        volunteers: user.reference_id
      }));

      console.log("API response for adding volunteer:", response);

      setIsLoadingVolunteers(true);
      await dispatch(getVolunteers(singleEvent?.id));

      setIsLoadingAnalytics(true);
      await dispatch(getEventAnalytics(singleEvent?.id));

      setIsAddVolunteerModalOpen(false);
    } catch (error) {
      console.error('Error adding volunteer:', error);
      alert('Failed to add volunteer. Please try again.');
    } finally {
      setIsAddingVolunteer(false);
      setIsLoadingVolunteers(false);
      setIsLoadingAnalytics(false);
    }
  };

  // Handler for InviteUserModal (multiple attendees invitation)
  const handleInviteAttendees = async (users, type) => {
    // console.log("Inviting attendees:", users);

    if (!users || users.length === 0) return;

    setIsInvitingAttendees(true);
    try {
      // Extract reference IDs from selected users
      const userIds = users.map(user =>
        String(user.reference_id || user.id)
      );

      const params = {
        id: singleEvent?.id,
        userIds: userIds
      }

      setIsLoadingAttendees(true);
      const res = await dispatch(PostInvaiteUsersToEvent(params))

      console.log("IAM from invite user", res)
      console.log("Inviting attendees with IDs:", params);

      // Refresh data after successful invitation
      setIsLoadingAnalytics(true);
      await dispatch(getEventAnalytics(singleEvent?.id));
      // If you have an API to get attendees, call it here
      // await dispatch(getEventAttendees(singleEvent?.id));

      setIsInviteUserModalOpen(false);
    } catch (error) {
      console.error('Error inviting attendees:', error);
      alert('Failed to invite attendees. Please try again.');
    } finally {
      setIsInvitingAttendees(false);
      setIsLoadingAttendees(false);
      setIsLoadingAnalytics(false);
    }
  };

  const handleCloseAddVolunteerModal = () => {
    setIsAddVolunteerModalOpen(false);
    setModalType('');
  };

  const handleCloseInviteUserModal = () => {
    setIsInviteUserModalOpen(false);
    setModalType('');
  };

  const handleCloseStatisticsModal = () => {
    setIsStatisticsModalOpen(false);
    setSelectedStatistic(null);
    setSelectedStatisticLabel('');
  };

  const handleViewAccessLogs = () => {
    dispatch(getEventAccessLogs({ eventId: singleEvent?.id }));
    navigate('/access-logs');
    console.log("View Access Logs clicked");
  };

  const handleGoBack = () => {
    navigate(-1); // Goes back to previous page
  };

  const primaryBlue = "#0044C6";

  return (
    <div style={{ width: "95%", minHeight: "100vh", background: "#f5f7fa" }}>
      {/* Add loading styles */}
      <style>{loadingStyles}</style>

      {/* Add pulse animation for skeletons */}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>

      {/* Cover Photo Section with Back Button Overlay */}
      <div style={{ position: "relative" }}>
        {singleEvent?.feature_image && (
          <div
            style={{
              width: "100%",
              height: "300px",
              backgroundImage: `url(${singleEvent.feature_image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            {/* Gradient Overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%)",
              }}
            />

            {/* Back Button on Cover Image */}
            <button
              onClick={handleGoBack}
              style={{
                position: "absolute",
                top: "20px",
                left: "20px",
                background: "rgba(255, 255, 255, 0.9)",
                border: "none",
                borderRadius: "40px",
                padding: "0.6rem 1.2rem",
                fontSize: "0.95rem",
                fontWeight: 600,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                color: "#0B1C33",
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                backdropFilter: "blur(5px)",
                zIndex: 10,
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "white";
                e.currentTarget.style.transform = "scale(1.02)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.9)";
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              <span style={{ fontSize: "1.2rem" }}>←</span> Back
            </button>

            {/* Event Category Badge on Cover Image */}
            {singleEvent?.event_category && (
              <div
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "20px",
                  background: primaryBlue,
                  color: "white",
                  borderRadius: "40px",
                  padding: "0.6rem 1.5rem",
                  fontSize: "0.9rem",
                  fontWeight: 600,
                  boxShadow: "0 4px 15px rgba(0,68,198,0.3)",
                  zIndex: 10,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {singleEvent.event_category}
              </div>
            )}
          </div>
        )}
      </div>

      <div
        style={{
          maxWidth: "1280px",
          margin: "0 auto",
          padding: "2rem 2rem",
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        }}
      >
        {/* Header Section */}
        <div style={{
          marginBottom: "2.5rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1rem"
        }}>
          <div>
            <h1
              style={{
                fontSize: "2rem",
                fontWeight: 700,
                margin: "0 0 0.5rem 0",
                color: "#0B1C33",
                letterSpacing: "-0.02em",
                lineHeight: 1.2,
              }}
            >
              {singleEvent?.title || "Event Title"}
            </h1>
            <div
              style={{
                display: "flex",
                gap: "2rem",
                color: "#5A6874",
                fontSize: "0.9rem",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              {!isOnlineEvent && (
                <span style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                  <span style={{ fontSize: "1rem" }}><SlLocationPin /></span> {eventLocation || "Location not specified"}
                </span>
              )}
              <span style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                <span style={{ fontSize: "1rem" }}><MdOutlineCalendarMonth /></span> {eventDate || "Date not specified"}
              </span>
              {singleEvent?.mode && (
                <span style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                  <span style={{ fontSize: "1rem" }}><IoCloudOfflineOutline /></span> {singleEvent.mode}
                </span>
              )}
              {/* Show event link for online events */}
              {isOnlineEvent && eventLink && (
                <EventLink link={eventLink} />
              )}
            </div>
          </div>

          {/* View Access Logs Button */}
          <button
            onClick={handleViewAccessLogs}
            style={{
              background: primaryBlue,
              color: "white",
              border: "none",
              borderRadius: "40px",
              padding: "0.8rem 2rem",
              fontSize: "1rem",
              fontWeight: 600,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              boxShadow: "0 4px 10px rgba(0,68,198,0.3)",
              transition: "all 0.15s",
              letterSpacing: "0.02em",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.02)";
              e.currentTarget.style.boxShadow = "0 6px 15px rgba(0,68,198,0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,68,198,0.3)";
            }}
          >
            <PiNotePencil />View Access Logs
          </button>
        </div>

        {/* Single Statistics Card */}
        <div
          style={{
            maxWidth: "100%",
            marginBottom: "3rem",
          }}
        >
          <div
            style={{
              background: "#FFFFFF",
              borderRadius: "24px",
              padding: "2rem",
              border: "1px solid #E9EDF4",
              boxShadow: "0 8px 20px -8px rgba(0,68,198,0.12)",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.8rem" }}>
              <h3
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 600,
                  color: primaryBlue,
                  margin: 0,
                  textTransform: "uppercase",
                  letterSpacing: "0.02em",
                }}
              >
                Event Statistics
              </h3>
              {isLoadingAnalytics && <LoadingSpinner size={16} />}
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "1.5rem 1rem",
              }}
            >
              {isLoadingAnalytics ? (
                <>
                  <StatItemSkeleton />
                  <StatItemSkeleton />
                  <StatItemSkeleton />
                  <StatItemSkeleton />
                  <StatItemSkeleton />
                  <StatItemSkeleton />
                  <StatItemSkeleton />
                  <StatItemSkeleton />
                </>
              ) : (
                <>
                  <StatItem
                    label="Total Tickets"
                    value={singleEvent?.attendees_limit || eventAnalytics?.attendee_metrics?.attendee_limit || 0}
                    onClick={handleStatisticClick}
                    isClickable={false}
                  />
                  <StatItem
                    label="Invited"
                    value={singleEvent?.no_of_invited_users || eventAnalytics?.attendee_metrics?.invited_attendees || 0}
                    onClick={handleStatisticClick}
                    isClickable={true}
                  />
                  <StatItem
                    label="Pending"
                    value={eventAnalytics?.attendee_metrics?.pending || 0}
                    onClick={handleStatisticClick}
                    isClickable={true}
                  />
                  <StatItem
                    label="Rejected"
                    value={eventAnalytics?.attendee_metrics?.rejected || 0}
                    onClick={handleStatisticClick}
                    isClickable={true}
                  />
                  <StatItem
                    label="Total Volunteers"
                    value={eventAnalytics?.volunteer_metrics?.active_volunteers || 0}
                    onClick={handleStatisticClick}
                    isClickable={true}
                  />
                  <StatItem
                    label="Total Attendees"
                    value={singleEvent?.no_of_attendees || eventAnalytics?.attendee_metrics?.total_attendees || 0}
                    onClick={handleStatisticClick}
                    isClickable={true}
                  />
                  <StatItem
                    label="Joined"
                    value={eventAnalytics?.attendee_metrics?.approved || 0}
                    onClick={handleStatisticClick}
                    isClickable={true}
                  />
                  <StatItem
                    label="Cancelled"
                    value={eventAnalytics?.attendee_metrics?.cancelled || 0}
                    onClick={handleStatisticClick}
                    isClickable={true}
                  />
                </>
              )}
            </div>
          </div>
        </div>

        {/* Volunteers & Attendees Sections */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))",
            gap: "2.5rem",
          }}
        >
          {/* Volunteers Column */}
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1.5rem",
              }}
            >
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: 600,
                  color: "#0B1C33",
                  margin: 0,
                  letterSpacing: "-0.01em",
                }}
              >
                Volunteers
              </h2>
              <button
                onClick={handleAddVolunteer}
                disabled={isAddingVolunteer}
                style={{
                  background: primaryBlue,
                  color: "white",
                  border: "none",
                  borderRadius: "40px",
                  padding: "0.6rem 1.6rem",
                  fontSize: "0.95rem",
                  fontWeight: 500,
                  cursor: isAddingVolunteer ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.4rem",
                  boxShadow: "0 4px 10px rgba(0,68,198,0.3)",
                  transition: "all 0.15s",
                  opacity: isAddingVolunteer ? 0.7 : 1,
                }}
                onMouseEnter={(e) => {
                  if (!isAddingVolunteer) {
                    e.currentTarget.style.transform = "scale(1.02)";
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                {isAddingVolunteer ? (
                  <>
                    <LoadingSpinner size={16} color="white" /> Adding...
                  </>
                ) : (
                  <>
                    <span style={{ fontSize: "1.2rem" }}>+</span> Add volunteer
                  </>
                )}
              </button>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem", background: "#FFFFFF", padding: "0.8rem", maxHeight: "80vh", overflowY: "scroll", scrollbarWidth: "none", borderRadius: "12px" }}>
              {isLoadingVolunteers ? (
                // Show skeleton loaders
                Array(5)?.fill(0)?.map((_, idx) => (
                  <PersonCardSkeleton key={`vol-skel-${idx}`} />
                ))
              ) : VolunteersData?.length > 0 ? (
                VolunteersData?.map((person, idx) => (
                  <PersonCard
                    key={`vol-${idx}`}
                    person={person}
                    eventData={singleEvent}
                    type="volunteer"
                    onViewDetails={handleViewPersonDetails}
                  />
                ))
              ) : (
                <div style={{
                  background: "#FFFFFF",
                  borderRadius: "16px",
                  padding: "2rem",
                  textAlign: "center",
                  color: "#6F7D95",
                  border: "1px dashed #E9EDF4",
                }}>
                  No volunteers added yet
                </div>
              )}

              {/* Load more indicator */}
              {isLoadingMore.volunteers && (
                <div style={{ textAlign: "center", padding: "1rem" }}>
                  <LoadingSpinner size={24} />
                </div>
              )}
            </div>
          </div>

          {/* Attendees Column */}
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1.5rem",
              }}
            >
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: 600,
                  color: "#0B1C33",
                  margin: 0,
                  letterSpacing: "-0.01em",
                }}
              >
                Attendees
              </h2>
              <button
                onClick={handleAddInvite}
                disabled={isInvitingAttendees}
                style={{
                  background: primaryBlue,
                  color: "white",
                  border: "none",
                  borderRadius: "40px",
                  padding: "0.6rem 1.6rem",
                  fontSize: "0.95rem",
                  fontWeight: 500,
                  cursor: isInvitingAttendees ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.4rem",
                  boxShadow: "0 4px 10px rgba(0,68,198,0.3)",
                  transition: "all 0.15s",
                  opacity: isInvitingAttendees ? 0.7 : 1,
                }}
                onMouseEnter={(e) => {
                  if (!isInvitingAttendees) {
                    e.currentTarget.style.transform = "scale(1.02)";
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                {isInvitingAttendees ? (
                  <>
                    <LoadingSpinner size={16} color="white" /> Inviting...
                  </>
                ) : (
                  <>
                    <span style={{ fontSize: "1.2rem" }}>+</span> Invite
                  </>
                )}
              </button>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem", background: "#FFFFFF", padding: "0.8rem", maxHeight: "80vh", overflowY: "scroll", scrollbarWidth: "none", borderRadius: "12px" }}>
              {isLoadingAttendees ? (
                // Show skeleton loaders
                Array(5).fill(0).map((_, idx) => (
                  <PersonCardSkeleton key={`att-skel-${idx}`} />
                ))
              ) : EventAttendees?.length > 0 ? (
                EventAttendees?.map((person, idx) => (
                  <AttendeesCard key={`att-${idx}`} person={person} />
                ))
              ) : (
                <div style={{
                  background: "#FFFFFF",
                  borderRadius: "16px",
                  padding: "2rem",
                  textAlign: "center",
                  color: "#6F7D95",
                  border: "1px dashed #E9EDF4",
                }}>
                  No attendees added yet
                </div>
              )}

              {/* Load more indicator */}
              {isLoadingMore.attendees && (
                <div style={{ textAlign: "center", padding: "1rem" }}>
                  <LoadingSpinner size={24} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Add Volunteer Modal - for single volunteer addition */}
      <AddVolunterModal
        isOpen={isAddVolunteerModalOpen}
        onClose={handleCloseAddVolunteerModal}
        type={modalType}
        onAddUser={handleAddVolunteerUser}
        isLoading={isAddingVolunteer}
      />

      {/* Invite User Modal - for multiple attendees invitation */}
      <InviteUserModal
        isOpen={isInviteUserModalOpen}
        onClose={handleCloseInviteUserModal}
        type={modalType}
        onAddUser={handleInviteAttendees}
        isLoading={isInvitingAttendees}
      />

      {/* Statistics Modal */}
      <StatisticsModal
        isOpen={isStatisticsModalOpen}
        onClose={handleCloseStatisticsModal}
        statisticLabel={selectedStatisticLabel}
        statisticData={selectedStatistic}
        eventId={singleEvent?.id}
      />
    </div>
  );
};

// Stat Item Component - Updated to handle click events
const StatItem = ({ label, value, onClick, isClickable = true }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (isClickable && onClick) {
      onClick(label, value);
    }
  };

  return (
    <div
      onClick={handleClick}
      onMouseEnter={() => isClickable && setIsHovered(true)}
      onMouseLeave={() => isClickable && setIsHovered(false)}
      style={{
        cursor: isClickable ? 'pointer' : 'default',
        transition: 'all 0.2s',
        transform: isHovered ? 'translateY(-2px)' : 'none',
      }}
    >
      <div style={{
        fontSize: "0.8rem",
        fontWeight: 500,
        color: "#6F7D95",
        marginBottom: "0.2rem",
        textTransform: "uppercase",
        letterSpacing: "0.02em",
      }}>
        {label}
      </div>
      <div style={{
        fontSize: "2rem",
        fontWeight: 700,
        color: isClickable && isHovered ? "#0044C6" : "#0B1C33",
        lineHeight: 1.1,
        transition: 'color 0.2s',
      }}>
        {value}
      </div>
    </div>
  );
};

// Person Card Component
const PersonCard = ({ person, eventData, type, onViewDetails }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        background: "#FFFFFF",
        borderRadius: "16px",
        padding: "1rem 1.5rem",
        border: isHovered ? "1px solid #537fd2" : "1px solid #0444C6",
        boxShadow: isHovered
          ? "0 12px 24px -12px rgba(0,68,198,0.2)"
          : "0 2px 8px rgba(0,0,0,0.02)",
        transition: "all 0.2s",
        cursor: "default",
        display: "flex",
        alignItems: "center",
        gap: "1rem",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          overflow: "hidden",
          background: "#E9EDF4",
          flexShrink: 0,
        }}
      >
        <img
          src={person.profile || "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg"}
          alt={person.name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          onError={(e) => {
            e.target.src = "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg";
          }}
        />
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, color: "#0B1C33", marginBottom: "0.2rem" }}>
          {person.name}
        </div>
        <div style={{ fontSize: "0.85rem", color: "#0044C6", wordBreak: "break-all" }}>
          {person.email}
        </div>
        {person.phone && (
          <div style={{ fontSize: "0.75rem", color: "#6F7D95", marginTop: "0.2rem" }}>
            {person.phone}
          </div>
        )}
      </div>

      {/* View Button */}
      <button
        onClick={() => onViewDetails(person, type)}
        style={{
          background: isHovered ? "#0044C6" : "white",
          color: isHovered ? "white" : "#0044C6",
          border: isHovered ? "none" : "1px solid #0044C6",
          borderRadius: "30px",
          padding: "0.4rem 1rem",
          fontSize: "0.85rem",
          fontWeight: 500,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "0.3rem",
          transition: "all 0.2s",
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
        onMouseEnter={(e) => {
          e.stopPropagation();
        }}
      >
        View
      </button>
    </div>
  );
};

// Attendees Card Component
const AttendeesCard = ({ person }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        background: "#FFFFFF",
        borderRadius: "16px",
        padding: "1rem 1.5rem",
        border: isHovered ? "1px solid #537fd2" : "1px solid #0444C6",
        boxShadow: isHovered
          ? "0 12px 24px -12px rgba(0,68,198,0.2)"
          : "0 2px 8px rgba(0,0,0,0.02)",
        transition: "all 0.2s",
        cursor: "default",
        display: "flex",
        alignItems: "center",
        gap: "1rem",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          overflow: "hidden",
          background: "#E9EDF4",
        }}
      >
        <img
          src={person.attendee?.profile_url || "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg"}
          alt={person.attendee?.name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          onError={(e) => {
            e.target.src = "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg";
          }}
        />
      </div>

      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, color: "#0B1C33", marginBottom: "0.2rem" }}>
          {person.attendee?.name || "Unknown Attendee"}
        </div>
        <div style={{ fontSize: "0.85rem", color: "#0044C6", wordBreak: "break-all" }}>
          {person.attendee?.email || "No email available"}
        </div>
        {person.attendee?.phone && (
          <div style={{ fontSize: "0.75rem", color: "#6F7D95", marginTop: "0.2rem" }}>
            {person.attendee?.phone}
          </div>
        )}
      </div>

      {/* Status Button */}
      <button
        style={{
          background: "white",
          color:
            person?.attendance_status === "APPROVED"
              ? "#008000"   // Green
              : person?.attendance_status === "REJECTED"
                ? "#FF0000"   // Red
                : person?.attendance_status === "PENDING"
                  ? "#FFA500"   // Orange
                  : "#000000",  // Default (optional)
          borderRadius: "30px",
          padding: "0.4rem 1rem",
          fontSize: "0.85rem",
          fontWeight: 500,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "0.3rem",
          transition: "all 0.2s",
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
        onMouseEnter={(e) => {
          e.stopPropagation();
        }}
      >
        {person?.attendance_status}
      </button>
    </div>
  );
};

export default EventDashboard;